import ReactDOM from 'react-dom/client';
import { isStaging } from './supabaseClient';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Entry split: path-routed Temis departments (/contracts, /materials) vs the
// hash-routed field tracker (everything else). Each world ships as its own chunk;
// crossing between them is a full-page navigation that re-runs this check.
const isDept = /^\/(contracts|materials|subs|lead-tracker)(\/|$)/.test(window.location.pathname);

// Test data, not the real thing: say so on every page of a preview.
if (isStaging) {
  const badge = document.createElement('div');
  badge.textContent = 'STAGING · test data';
  badge.setAttribute('role', 'note');
  badge.style.cssText = 'position:fixed;left:50%;bottom:10px;transform:translateX(-50%);z-index:20000;pointer-events:none;'
    + 'padding:4px 12px;border-radius:999px;background:#f59e0b;color:#1a1a1a;font:700 11px/1.4 system-ui,sans-serif;'
    + 'letter-spacing:.5px;box-shadow:0 2px 10px rgba(0,0,0,.35);opacity:.92';
  document.body.appendChild(badge);
}

(isDept ? import('./departments/DepartmentsApp') : import('./App'))
  .then(({ default: Root }) => root.render(<Root />));
